// Tiny consent store — uses localStorage so the choice persists across visits.

const KEY = "np_cookie_consent_v1";

export const CONSENT_DEFAULT = {
  necessary: true, // always true
  marketing: false,
  decided: false,
  updatedAt: null,
};

export function readConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...CONSENT_DEFAULT };
    const parsed = JSON.parse(raw);
    return {
      necessary: true,
      marketing: !!parsed.marketing,
      decided: !!parsed.decided,
      updatedAt: parsed.updatedAt || null,
    };
  } catch {
    return { ...CONSENT_DEFAULT };
  }
}

export function writeConsent(next) {
  const value = {
    necessary: true,
    marketing: !!next.marketing,
    decided: true,
    updatedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* ignore */
  }
  // Propaga la decisione al Consent Mode v2 di Google (GA4 + Google Ads)
  try {
    if (typeof window !== "undefined" && typeof window.npGtagConsentUpdate === "function") {
      window.npGtagConsentUpdate(value.marketing);
    }
  } catch { /* ignore */ }
  // notify listeners (same tab + cross-tab)
  try {
    window.dispatchEvent(new CustomEvent("np-consent-changed", { detail: value }));
  } catch {
    /* ignore */
  }
  return value;
}

export function clearConsent() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent("np-consent-changed", { detail: { ...CONSENT_DEFAULT } }));
  } catch {
    /* ignore */
  }
}
